<div [ngClass]="{'sticky-wrapper': true, 'scrolled': isScrolled}">

  <div *ngIf="showNotification" id="notification-bar" class="notification-bar">
    <div class="notification-content">
      <div class="notification-container">
        <div class="notification-flex">
          <p class="notification-text">
            APPLICATION OPEN FOR ADMISSIONS 2025.UNLOCK SCHOLARSHIP BENEFITS.
          </p>
          <a href="https://apply.onesb.edu.in" class="register-button">
            <span  style="font-size: 12px; font-family: Montserrat, sans-serif;">
              REGISTER HERE</span><i class="fas fa-external-link-alt" style="margin-left: 5px;"></i>
          </a>
          <span (click)="closeNotification()" class="close-icon">&times;</span>
        </div>
       
      </div>
    </div>
  </div>
  <div class="mobile-header1" *ngIf="isMobile">
    <div class="mobile-header-inner">
      <a class="navbar-brand" href="/">
        <img  [src]="isScrolled ? 'assets/img/newlogo/ONESB-LOGO-OG.png':themeLogo" alt="Onesb" class="logo" width="150" id="logo" />
      </a>
      
  
      <button class="hamburger-btn" (click)="toggleMobileMenu()"   [ngStyle]="{ color: isScrolled ? 'black' : 'white' }">
        {{ mobilemenuOpen ? '' : '☰' }}
        <h2 style="font-size: 10px;"  [ngStyle]="{ color: isScrolled ? 'black' : 'white' }">MENU</h2>
      </button>
      
    </div>
  </div>
 
    

</div>

<div *ngIf="isMobile && mobilemenuOpen" class="overlay" (click)="toggleMobileMenu()">
  <div class="mobile-menu" (click)="$event.stopPropagation()">
    <div class="top-bar">
      <!-- Close button -->
      <button class="close-btn" (click)="toggleMobileMenu()">X</button>
    </div>

    <!-- CTA buttons -->
    <button  href="/program" class="cta-outline" style="font-family: Montserrat, sans-serif; margin-right: 4px;">
      COMPARE OUR PROGRAMS
    </button>
    <button href="https://apply.onesb.edu.in" class="cta-solid" style="font-family: Montserrat, sans-serif;">
      APPLY
    </button>

    <!-- Menu items -->
    <div class="menu-item" *ngFor="let section of menu">
      <div class="menu-header" (click)="toggleSection(section)" style="font-family: Montserrat, sans-serif;">
        <a [routerLink]="section.link" class="red1">{{ section.title }}</a>

        <span class="icons">{{ section.expanded ? '-' : '+' }}</span>
      </div>

      <div *ngIf="section.expanded" class="submenu">
        <div *ngFor="let item of section.children" class="submenu-item" style="font-family: Montserrat, sans-serif;">
          <a [routerLink]="item.link" style="color: white;">{{ item.title }}</a>
        </div>
      </div>
     <!--  <div
        class="menu-header"
        (click)="toggleSection(section)"
        style="font-family: Montserrat, sans-serif;"
      >
        <span class="red1">{{ section.title }}</span>
        <span class="icons">{{ section.expanded ? '-' : '+' }}</span>
      </div>

      <div *ngIf="section.expanded" class="submenu">
        <div
          *ngFor="let item of section.children"
          class="submenu-item"
          [ngStyle]="item.isBold ? {'font-weight': 'bold'} : {}"
          style="font-family: Montserrat, sans-serif;">
          {{ item.title }}
        </div>
      </div> -->
    </div>
  </div>
</div>

<div style="position: relative;background-color: #00808f; padding: 10px;">
  <!-- social-nav.component.html -->
  <div class="container" >
    <nav class="navbar navbar-expand-lg" >
      <div class="d-flex justify-content-between align-items-center w-100">
        
        
        <!-- Left-aligned Social Media Icons -->
        <div class="d-flex align-items-center">
          <a href="https://www.instagram.com/oneschoolofbusiness"><i class="fa fa-instagram text-white mx-2"></i></a>
          <a href="https://in.linkedin.com/in/one-school-of-business"><i class="fa fa-linkedin text-white mx-2"></i></a>
          <a href="https://www.facebook.com/ONESBBNGLR/"><i class="fa fa-facebook text-white mx-2"></i></a>
          <!-- <a href="#"><i class="fa fa-twitter text-white mx-2"></i></a> -->
          <a href="https://www.youtube.com/channel/UCLbMueEZYVMSd1mF30vLr7Q"><i class="fa fa-youtube text-white mx-2"></i></a>
        </div>
        
        <!-- Navbar Toggle Button -->
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
  
        <!-- Right-aligned Navigation Links -->
        <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul class="navbar-nav" style="font-size: x-small;">
            <li class="nav-item dropdown" ngbDropdown (mouseenter)="dropdown.open()" (mouseleave)="dropdown.close()" #dropdown="ngbDropdown">
              <a class="nav-link dropdown-toggle text-white" id="blogsDropdown" ngbDropdownToggle>BLOGS</a>
              <ul class="dropdown-menu" ngbDropdownMenu style="font-size: x-small;">
                <li style="border-bottom: 1px solid #ddd; width: 100%;padding: 6px 0px;
                align-items: center;
                text-align: left;"><a class="dropdown-item" href="#">ACADEMIC</a></li>
                <li style="border-bottom: 1px solid #ddd; width: 100%;padding: 6px 0px;
                align-items: center;
                text-align: left;"><a class="dropdown-item" href="#"> SOCIAL</a></li>
              <!--   <li style="border-bottom: 1px solid #ddd; width: 100%;padding: 6px 0px;
                align-items: center;
                text-align: left;"><a class="dropdown-item" href="#">INSIGHTS</a></li> -->
              </ul>
            </li>
            <li class="nav-item"><a class="nav-link text-white" href="/news">NEWS</a></li>
            <li class="nav-item"><a class="nav-link text-white" href="/events">EVENTS</a></li>
            <!-- <li class="nav-item"><a class="nav-link text-white" href="#">INTERNATIONAL OFFICES</a></li>
            <li class="nav-item"><a class="nav-link text-white" href="#">ONLINE CAMPUS</a></li> -->
            <li class="nav-item"><a class="nav-link text-white" href="/contact">CONTACT</a></li>
            <!-- <li class="nav-item">
              <a href="#"><i class="fas fa-robot text-white mx-2" style="margin-top: 8px; "></i></a>
            </li> -->
          </ul>
        </div>
      </div>
    </nav>
  </div>
</div>
<div>
  
   
      <div class="main-menu">
        <div class="menu-right pull-right w-100" style="width: 100% !important;">
          <div>
            <app-menu></app-menu>
          </div>
        </div>
   
  </div>
</div>